import { formatDuration, intervalToDuration } from "date-fns";

/**
 * Formats the length of a media request's recording period as a human-readable
 * string, e.g. "2 hours 5 minutes", "10 minutes", or "20 seconds". Seconds are
 * only included for short periods (< 5 minutes) to keep longer periods concise.
 *
 * Shared by the dashboard and firmware media-request views so both format the
 * "Recording Period" column identically.
 *
 * NOTE: written to be correct under both date-fns v2 (dashboard) and v3
 * (firmware). v3's `intervalToDuration` OMITS zero fields (v2 keeps them as 0),
 * so the unit checks coalesce undefined -> 0. Without that, a strict `=== 0`
 * check silently falls through to the no-seconds format under v3 and
 * `formatDuration` returns "" for any sub-minute period.
 */
export function formatRecordingPeriodDuration(start: Date | number, end: Date | number): string {
    const duration = intervalToDuration({ start, end });
    const days = duration.days ?? 0;
    const hours = duration.hours ?? 0;
    const minutes = duration.minutes ?? 0;
    const format = days === 0 && hours === 0 && minutes < 5
        ? ["days", "hours", "minutes", "seconds"]
        : ["days", "hours", "minutes"];
    return formatDuration(duration, { format });
}
